@if (form) {
<div>
	<lib-card [isForm]="true" [title]="'Profile details'">
		<ui-text-form-field
			[title]="'First name'"
			[valueAsSignal]="form.firstName"
			[maxLength]="50"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Last name'"
			[valueAsSignal]="form.lastName"
			[maxLength]="50"
		></ui-text-form-field>

		<ui-select-item-field
			class="push-top-md"
			[title]="'Gender'"
			[valueAsSignal]="form.gender"
			[items]="genderSelectItems"
		></ui-select-item-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Location'"
			[valueAsSignal]="form.location"
			[maxLength]="100"
		></ui-text-form-field>

		<ui-select-item-field
			class="push-top-md"
			[placeholder]="'Select unit...'"
			[title]="'Preferred units'"
			[valueAsSignal]="form.preferredUnit"
			[items]="preferredUnitSelectItems"
		></ui-select-item-field>

		<ui-form-save-button [saveHandler]="saveHandler()" [logHandler]="formLogHandler()"></ui-form-save-button>
	</lib-card>

	<lib-card [isForm]="true" [title]="'Danger zone'" class="push-top-md">
		<lib-message [type]="'warning'" [title]="'Delete account warning'">
			Once you delete your account, you will not be able to recover it.
		</lib-message>

		<lib-button
			class="push-top"
			libConfirm
			[confirmMode]="'delete'"
			[confirmText]="'Are you sure to delete your account?'"
			(confirm)="handleDeleteAccount()"
			[buttonType]="'delete'"
			[buttonSize]="'large'"
		>
			Delete account
		</lib-button>
	</lib-card>
</div>
}
